module.exports = __webpack_public_path__ + "media/images/site/erik-sem-borda-28db2b4818a8e2adb5613da075190fbd.png";